import React, { useState } from 'react';
import { Select } from 'antd';
import { useTransitionNavigation } from '../../../~reusables/contexts/TransitionContext';
import type { NavTabItem } from './navModel';
import {
  PageHeaderWrapper,
  PageTitle,
  SubTabLink,
  SubTabsNav,
  SubTabsSelect,
} from './NavStyles';

interface SubTabsPageHeaderProps {
  title: string;
  /** Accessible name for the sub-navigation, e.g. "Settings sections". */
  navLabel: string;
  tabs: NavTabItem[];
  activeKey: string | null;
}

/** Page title with segmented sub-tabs, used for app and account settings. */
export const SubTabsPageHeader: React.FC<SubTabsPageHeaderProps> = ({
  title,
  navLabel,
  tabs,
  activeKey,
}) => {
  const { navigateWithTransition } = useTransitionNavigation();
  const [selectOpen, setSelectOpen] = useState(false);

  return (
    <PageHeaderWrapper>
      <PageTitle>{title}</PageTitle>
      {/* Phones get a dropdown; the tabs don't fit and hide their overflow */}
      <SubTabsSelect>
        <Select
          aria-label={navLabel}
          open={selectOpen}
          onOpenChange={setSelectOpen}
          value={activeKey ?? undefined}
          options={tabs.map((tab) => ({ value: tab.key, label: tab.label }))}
          onChange={(key: string) => {
            setSelectOpen(false);
            const tab = tabs.find((t) => t.key === key);
            if (tab) navigateWithTransition(tab.to);
          }}
        />
      </SubTabsSelect>
      <SubTabsNav aria-label={navLabel}>
        {tabs.map((tab) => {
          const active = tab.key === activeKey;
          return (
            <SubTabLink
              key={tab.key}
              to={tab.to}
              $active={active}
              aria-current={active ? 'page' : undefined}
            >
              {tab.label}
            </SubTabLink>
          );
        })}
      </SubTabsNav>
    </PageHeaderWrapper>
  );
};
